import axios from 'axios';

const setAuthToken = (token: any) => {
	if (token) {
		axios.defaults.headers.common['x-auth-token'] = `Bearer ${token}`;
		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		axios.defaults.headers.common['Accept-Language'] = 'en';
	} else {
		delete axios.defaults.headers.common['x-auth-token'];
		delete axios.defaults.headers.common['Authorization'];
		delete axios.defaults.headers.common['Accept-Language'];
	}
};

export default setAuthToken;
